import React,{useState} from 'react'

import Canvas from "../canvas/Canvas"

import thumb17 from '../images/thumb_17.jpg';
import thumb18 from '../images/thumb_18.jpg';
import thumb19 from '../images/thumb_19.jpg';

import img17 from '../images/17.png';
import img18 from '../images/18.png';
import img19 from '../images/19.png';

import {Modal} from 'react-bootstrap';
import "./modal.css";

export default function Cataract(){
    const [show,setShow] = useState(false);
    const [title,setTitle] = useState("Eye Lids");
    const [showImage,setShowImage] = useState(img17);
 
    const handleShow = (subtitle,imagename)=>{
         setTitle(subtitle)
         setShowImage(imagename)
         setShow(true)
    }
    return(
        <>
           <div className="card card-custom gutter-b">
                <div className="card-header">
                    <div className="card-title">
                        <h3 className="card-lable">
                            Cataract
                        </h3>
                    </div>
                </div>
                <div className="card-body">
                    <div className="row">

                        <div className="col-lg-2">
                            <div className="card card-custom overlay">
                                <div className="card-body p-0">
                                    <div className="overlay-wrapper">
                                    <img alt="excimage"  src={thumb17}  className="w-100 rounded" />
                                    <h6 className="text-muted ml-2 mt-2">Cortical</h6>
                                    </div>
                                    <div className="overlay-layer">
                                        <button className="btn font-weight-bold btn-primary btn-shadow" onClick={()=>handleShow("Cataract - Cortical",img17)}>Draw</button>
                                    </div>
                                </div>
                            </div>
                        </div> 
                        <div className="col-lg-2">
                            <div className="card card-custom overlay">
                                <div className="card-body p-0">
                                    <div className="overlay-wrapper">
                                    <img alt="excimage"  src={thumb18}  className="w-100 rounded" />
                                    <h6 className="text-muted ml-2 mt-2">Nuclear Sclerotic</h6>
                                    </div>
                                    <div className="overlay-layer">
                                        <button className="btn font-weight-bold btn-primary btn-shadow" onClick={()=>handleShow("Cataract - Cortical",img18)}>Draw</button>
                                    </div>
                                </div>
                            </div>
                        </div> 
                        <div className="col-lg-2">
                            <div className="card card-custom overlay">
                                <div className="card-body p-0">
                                    <div className="overlay-wrapper">
                                    <img alt="excimage"  src={thumb19}  className="w-100 rounded" />
                                    <h6 className="text-muted ml-2 mt-2">Posterior Capsular</h6>
                                    </div>
                                    <div className="overlay-layer">
                                        <button className="btn font-weight-bold btn-primary btn-shadow" onClick={()=>handleShow("Cataract - Posterior Capsular",img19)}>Draw</button>
                                    </div>
                                </div>
                            </div>
                        </div> 



                    </div>
                </div>
            </div> 
            <Modal
                show={show}
                size="lg"
                onHide={()=>setShow(false)}
                dialogClassName="modal-90w"
                >
                    <Modal.Header closeButton>
                      
                        <Modal.Title>
                            Eye Draw - {title}
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>     
                      {/*   <Image src={img1} fluid />*/}
                      <div style={{height:"70vh",width:"60vw"}}>
                      <Canvas image={showImage} />
                      </div>
                     
                    </Modal.Body>
                </Modal>            
        </>
    )
}